import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { spacing, breakpoints, colors, radius, fonts, fontSize } = redesignTheme;

export const useHomePageInnovativeToolsSectionStyles = makeStyles(() => ({
  innovativeGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.md,
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
  },
  innovativeCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: spacing.md,
    borderRadius: radius.lg,
    backgroundColor: colors.background,
    border: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    minHeight: 220,
    boxSizing: 'border-box',
    width: '100%',
    // Explicit color: iOS Safari paints button SVGs with default link blue otherwise
    color: colors.text,
    WebkitAppearance: 'none',
    appearance: 'none',
    '&:hover $innovativeArrowWrap': {
      backgroundColor: 'rgba(56, 56, 56, 0.2)',
    },
  },
  innovativeIconWrap: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  innovativeIcon: {
    width: 33,
    height: 33,
    color: colors.text,
  },
  innovativeContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    flex: 1,
    width: '100%',
    alignItems: 'stretch',
  },
  innovativeTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.xl,
    color: colors.text,
    lineHeight: 'normal',
  },
  innovativeDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 'normal',
  },
  innovativeAvailability: {
    fontFamily: fonts.opensansSemiBold,
  },
  innovativeFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  innovativeArrowWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.sm,
    borderRadius: radius.lg,
    backgroundColor: 'rgba(56, 56, 56, 0.12)',
    color: colors.primaryDark,
    transition: 'background-color 0.2s ease',
  },
}));
